import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Message from 'components/Message';
import Button from 'components/Button';
import { bem } from 'helpers/class-name';
import { PAGE_LAYOUT_VARIANT } from 'features/App';
import appMessages from 'features/App/App.messages';
import { PageLayoutContext } from 'features/App/Contexts';
import { intlMessage } from 'constants/propTypes';
import './SaveBar.scss';

const { block, element } = bem('save-bar');

const SaveBar = ({
  visible,
  submitting,
  desktopNavIsCollapsed,
  submitMessage = appMessages.save,
  formName,
  additionalButtons,
  notice,
  disabled,
}) =>
  ReactDOM.createPortal(
    <PageLayoutContext.Consumer>
      {({ layoutInfo: { pageLayout } }) => (
        <div className={block({ visible })}>
          <div
            className={element('button-container-wrap', {
              desktopNavIsCollapsed,
              wide: pageLayout === PAGE_LAYOUT_VARIANT.WIDE,
            })}>
            <div> {!!notice && notice}</div>
            <div>
              {!!additionalButtons && additionalButtons}
              <Message
                as={Button}
                form={formName}
                type={Button.TYPES.SUBMIT}
                message={submitMessage}
                waiting={submitting}
                disabled={disabled}
              />
            </div>
          </div>
        </div>
      )}
    </PageLayoutContext.Consumer>,
    document.body
  );

SaveBar.propTypes = {
  visible: PropTypes.bool,
  submitting: PropTypes.bool,
  desktopNavIsCollapsed: PropTypes.bool,
  formName: PropTypes.string,
  submitMessage: intlMessage,
  additionalButtons: PropTypes.node,
  notice: PropTypes.node,
  disabled: PropTypes.bool,
};

export default SaveBar;
